<template>
  <Modal
    v-model="_value"
    width="500"
    title="透传数据"
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">
    <Form ref="loginForm" :model="dataDownlinkTransmission">
      <FormItem prop="code">
        <label style="display: inline-block; width: 100px;">透传通道</label>
        <Select v-model="transDataType">
          <Option value=0 key=0>GNSS数据</Option>
          <Option value=11 key=11>IC卡数据</Option>
          <Option value=65 key=65>串口1</Option>
          <Option value=66 key=66>串口2</Option>
        </Select>
      </FormItem>
      <FormItem prop="hex">
        <label style="display: inline-block; width: 100px;">数据格式</label>
        <Select v-model="ishex">
          <Option value=0 key=0>文本</Option>
          <Option value=1 key=1>HEX</Option>
        </Select>
      </FormItem>
      <FormItem prop="content">
        <label style="display: inline-block; width: 200px;">内容格式</label>
          <Input type="textarea" v-model="dataDownlinkTransmission.content" placeholder="内容格式"></Input>
      </FormItem>
      <FormItem prop="buttons">
        <Button size="small" @click="onSend">发送</Button>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'datadownlinktransmissionmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        transDataType:0,
        ishex:0,
        dataDownlinkTransmission: {
          id:null,
          transDataType:null,
          hex:null,
          content:null
        }
      }
    },
    methods: {
      ...mapActions([
        'NetCommandServ_DataDownlinkTransmission'
      ]),
      onSend(){

        if(this.ishex == 0){
          this.dataDownlinkTransmission.hex = false
        }else{
          this.dataDownlinkTransmission.hex = true
        }

        this.dataDownlinkTransmission.transDataType = parseInt(this.transDataType, 10)

        store.dispatch('NetCommandServ_DataDownlinkTransmission', {
          params: this.dataDownlinkTransmission,
          urlparams: null
        }).then(() => {
          this.$Message.success('下发成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      onOk() {

      },
      visibleChange(val) {
        if(val){
          this.transDataType = 0
          this.ishex = 0
          this.dataDownlinkTransmission.id = this._initValue
          this.dataDownlinkTransmission.transDataType = 0
          this.dataDownlinkTransmission.hex = false
          this.dataDownlinkTransmission.content = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
